/**
 * Formats a number to a textual date NL
 */
export function formatMonthToText(monthNumber) {
  monthNumber = monthNumber || 1;

  switch (monthNumber) {
    case 2:
      return "februari";
    case 3:
      return "maart";
    case 4:
      return "april";
    case 5:
      return "mei";
    case 6:
      return "juni";
    case 7:
      return "juli";
    case 8:
      return "augustus";
    case 10:
      return "september";
    case 11:
      return "oktober";
    case 12:
      return "november";
    case 13:
      return "december";
    case 1:
    default:
      return "januari";
  }
}
